import api from './api';
import { useloggedUserInfo } from "../store/UserInfo";

class userAuthService {
    async getCurrentUserDetail(userId, actionType) {
        let optionaParamersType = "00Test";
        let info;
        var TimeZone;
        debugger;
        await api.get(`UserProfile/GetUserInfo/${userId}/${actionType}/${optionaParamersType}`).then(response => (
            info = response,
            console.log("getCurrentUserDetail", info.data),
            useloggedUserInfo().setUser(info.data),
            
            localStorage.removeItem('userinfo'),
            localStorage.removeItem("dashboardItems"),
            localStorage.setItem("dashboardItems", "True"),
            localStorage.setItem('userinfo', JSON.stringify(response)),
            localStorage.removeItem('companyId'),

            localStorage.setItem("companyId", response.data.companyId),

            localStorage.removeItem('SettingObserver'),
            localStorage.setItem("SettingObserver", response.observerSettingName),
            localStorage.removeItem('SettingEmployee'),
            localStorage.setItem("SettingEmployee", response.employeeSettingName),
            localStorage.removeItem('TimeZone'),
             TimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone, //response.timeZone;
            localStorage.setItem("TimeZone", TimeZone),

            localStorage.setItem('sliderMenu', JSON.stringify(1)),
            localStorage.setItem("usersucess", "yes"),

            localStorage.removeItem('primaryLogo'),
            localStorage.removeItem('secondaryLogo'),
            localStorage.removeItem('companyName'),

            localStorage.setItem("primaryLogo", response.data.primaryLogo),
            localStorage.setItem("secondaryLogo", response.data.secondaryLogo),
            localStorage.setItem("companyName", response.data.companyName),
            localStorage.setItem("userType", response.data.userType)
        ))
    }

    //async getCurrentUserDetailCompanyLogo(userId, actionType) {
    //    let optionaParamersType = "00Test";
    //    let info;
    //    var TimeZone;
    //    return await api.get(`UserProfile/GetUserInfo/${userId}/${actionType}/${optionaParamersType}`);
    //}

    async GetUser(userId, actionType) {
        let optionaParamersType = "00Test";
        return await api.get(`UserProfile/GetUserInfo/${userId}/${actionType}/${optionaParamersType}`);
    }

    async GetModuleList(userId, opType) {
        return await api.get(`Module/GetModuleList/${userId}/${opType}`);
    }

    async GetCompanyUserInfo(CompanyUserLoginInfo) {
        return await api.post(`Account/GetCompanyUserInfo`, CompanyUserLoginInfo);
    }

    getUserModulePermissions(userId, actionType) {
        if (actionType == '' || actionType == null || typeof actionType == undefined) {
            actionType = '00Test';
        }
        if (localStorage.getItem("actionType") == 'AsAObserver') {
            actionType = localStorage.getItem("actionType");
        }
        return api.get(`common/GetUserModulePermissionList/${userId}`);
    }
}

export default new userAuthService();